import { useState } from "react";
import { Button } from "../../components/ui/button";

import { ShieldUser, BookmarkCheck, ShieldCheck, Headset } from "lucide-react";
import skincareImg from "../../skincare.png";
import sexualHealthImg from "../../sexualhealth.png";
import hairGrowthImg from "../../hairgrowth.png";
import weightLossImg from "../../weightloss.png";
import mentalHealthImg from "../../meantalhealth1.jpg";
import whychooseimg1 from "../../why-choose-img-1.jpg";
import whychooseimg2 from "../../why-choose-img-2.jpg";

import Header from "../../components/VibrantSolComponents/Header";
import Footer from "../../components/VibrantSolComponents/Footer";
function HomePage() {
  return (
    <>
      <div className="min-h-screen">
        <Header />
        <section class="pt-16">
          <div class="max-w-7xl mx-auto px-4">
            <div class="flex flex-col items-center text-center">
              <h1 class="text-4xl secdory-font md:text-5xl !leading-tight">
                Transform Your
                <br />
                <span>Health & Confidence</span>
              </h1>
              <p className="text-xl text-slate-600 max-w-2xl mx-auto">
                We provide comprehensive, personalized healthcare solutions
                designed to help you look, feel, and live your best life.
              </p>
            </div>
          </div>
        </section>
        <section>
          <div class="max-w-7xl mx-auto px-4 pt-10 pb-20">
            <div class="flex flex-col lg:flex-row gap-8">
              <div
                class="w-full lg:w-1/2 animate__fadeInUp animate__animated"
                data-animate="fadeInUp"
              >
                <div class="service-item text-center">
                  <img src={skincareImg} alt="Skin Care" class="mx-auto" />
                  <div class="service-label mt-4 text-md font-semibold">
                    Skin Care
                  </div>
                </div>
              </div>

              <div class="w-full lg:w-1/2 flex flex-col gap-8">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div
                    class="service-item text-center animate__fadeInUp animate__animated"
                    data-animate="fadeInUp"
                  >
                    <img
                      src={sexualHealthImg}
                      alt="Sexual Health"
                      class="mx-auto"
                    />
                    <div class="service-label mt-4 text-md font-semibold">
                      Sexual Health
                    </div>
                  </div>
                  <div
                    class="service-item text-center animate__fadeInUp animate__animated"
                    data-animate="fadeInUp"
                  >
                    <img
                      src={hairGrowthImg}
                      alt="Hair Regrowth"
                      class="mx-auto"
                    />
                    <div class="service-label mt-4 text-md font-semibold">
                      Hair Regrowth
                    </div>
                  </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div class="service-item text-center">
                    <img
                      src={weightLossImg}
                      alt="Weight Loss"
                      class="mx-auto"
                    />
                    <div class="service-label mt-4 text-md font-semibold">
                      Weight Loss
                    </div>
                  </div>
                  <div class="service-item text-center">
                    <img
                      src={mentalHealthImg}
                      alt="Mental Health"
                      class="mx-auto"
                    />
                    <div class="service-label mt-4 text-md font-semibold">
                      Mental Health
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="bg-section-6 py-20">
          <div class="max-w-7xl mx-auto px-4">
            <div class="flex justify-center items-start text-center mb-12">
              <div>
                <h3 class="text-base uppercase text-xaxathrive-primary font-semibold">
                  how it work
                </h3>
                <h2 class="text-3xl md:text-5xl mb-4 secdory-font">
                  Guiding you our process
                </h2>
                <p class="text-lg text-slate-600 max-w-2xl mx-auto">
                  Choose your treatment, consult our experts, and receive your
                  order or results quickly and directly
                </p>
              </div>
            </div>

            <div class="how-work-step-box justify-center">
              <div class="how-work-step-item">
                <div class="how-work-step-no">
                  <h3>01</h3>
                </div>
                <div class="how-work-step-content">
                  <h3 className="secdory-font">01. Choose Treatment</h3>
                  <p>
                    Pick your area of concern — Hair Regrowth, Skin Care, Sexual
                    Health, Weight Loss, or Mental Health.
                  </p>
                </div>
              </div>

              <div class="how-work-step-item">
                <div class="how-work-step-no">
                  <h3>02</h3>
                </div>
                <div class="how-work-step-content">
                  <h3 className="secdory-font">02. Initial consultation</h3>
                  <p>
                    Answer a few quick questions and connect with a licensed
                    professional online.
                  </p>
                </div>
              </div>

              <div class="how-work-step-item">
                <div class="how-work-step-no">
                  <h3>03</h3>
                </div>
                <div class="how-work-step-content">
                  <h3 className="secdory-font">03. Delivery</h3>
                  <p>
                    Get your personalized treatment plan or products delivered
                    to your door.
                  </p>
                </div>
              </div>

              <div class="how-work-step-item">
                <div class="how-work-step-no">
                  <h3>04</h3>
                </div>
                <div
                  class="how-work-step-content"
                  style={{ maxWidth: "inherit" }}
                >
                  <h3 className="secdory-font">04. Result</h3>
                  <p>Your journey to better health, with measurable results.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="py-20">
          <div class="max-w-7xl mx-auto px-4">
            <div class="w-full">
              <div class="flex flex-col lg:flex-row items-start gap-10">
                <div class="relative w-full why-choose-image">
                  <img
                    class="w-full h-auto rounded-lg shadow-md"
                    src={whychooseimg1}
                    alt=""
                  />

                  <div class="absolute -bottom-8 -right-8 w-24 h-24">
                    <img src="images/contact-circle-img.svg" alt="" />
                  </div>
                </div>

                <div class="why-choose-content">
                  <div class="section-title">
                    <h3 class="text-base uppercase text-xaxathrive-primary !font-semibold secdory-font">
                      why choose us
                    </h3>
                    <h2 class="text-3xl md:text-5xl mb-5 secdory-font">
                      Expert Care, Lasting Beauty Results
                    </h2>
                    <p className="text-lg text-slate-600 ">
                      We provide personalized, innovative care in a warm and
                      supportive environment focused on your well-being.
                    </p>
                  </div>

                  <div class="why-choose-list mt-9">
                    <div class="why-choose-item">
                      <div class="icon-box">
                        <ShieldUser />
                      </div>
                      <div class="why-choose-item-content">
                        <h3 className="secdory-font">
                          experienced professionals
                        </h3>
                      </div>
                    </div>

                    <div class="why-choose-item">
                      <div class="icon-box">
                        <BookmarkCheck />
                      </div>
                      <div class="why-choose-item-content">
                        <h3 className="secdory-font">Customized treatments</h3>
                      </div>
                    </div>

                    <div class="why-choose-item">
                      <div class="icon-box">
                        <ShieldCheck />
                      </div>
                      <div class="why-choose-item-content">
                        <h3 className="secdory-font">
                          Premium-quality products
                        </h3>
                      </div>
                    </div>

                    <div class="why-choose-item">
                      <div class="icon-box">
                        <Headset />
                      </div>
                      <div class="why-choose-item-content">
                        <h3 className="secdory-font">
                          Personalized customer care
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div class="why-choose-body">
                    <div class="why-choose-body-image">
                      <img src={whychooseimg2} alt="" />
                    </div>

                    <div class="why-choose-body-content">
                      <h3 class="text-3xl md:text-5xl !font-bold mb-4 secdory-font">
                        Results You Can Trust
                      </h3>
                      <p className="text-lg text-slate-600 ">
                        We deliver visible results with a focus on safety,
                        comfort, and discretion, offering services to help you
                        look and feel your best inside and out.
                      </p>
                      <Button className="bg-xaxathrive-primary hover:bg-blue-700">
                        Contact Now
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
export default HomePage;
